/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetBatchRequest = {
  batchId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetBatchRequest$inboundSchema: z.ZodType<
  GetBatchRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  batch_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "batch_id": "batchId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetBatchRequest$Outbound = {
  batch_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetBatchRequest$outboundSchema: z.ZodType<
  GetBatchRequest$Outbound,
  z.ZodTypeDef,
  GetBatchRequest
> = z.object({
  batchId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    batchId: "batch_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getBatchRequestToJSON(
  getBatchRequest: GetBatchRequest,
): string {
  return JSON.stringify(GetBatchRequest$outboundSchema.parse(getBatchRequest));
}
export function getBatchRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetBatchRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetBatchRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetBatchRequest' from JSON`,
  );
}
